import { ApolloError } from '@apollo/client'
import { getFirstGraphqlError, handleError, handleValidationError, isValidationError } from 'components/error'
import { FlagsContextModel } from 'config/useFlagsContext'
import { AtendimentoIndividualInput, TipoAtendimentoProfissional } from 'graphql/types.generated'
import { ErrorObject } from 'util/validation'
import { getAtendimentoIndividualInputErrorsFromRetificacao } from 'view/retificacao-atendimento/util-retificacaoAtendimento'

import { convertSoapErrorsFromBackend } from './converter-soapErrorsFromBackend'
import { showValidationErrorsSoapModal } from './showValidationErrorsSoapModal'

export function handleBackendErrorsSoap(
  apolloError: Readonly<ApolloError>,
  isEstagio: boolean,
  flags: Readonly<FlagsContextModel>,
  tipoAtendProf: TipoAtendimentoProfissional,
  isAtendimentoOdonto: boolean,
  isRetificacao: boolean
) {
  const firstError = getFirstGraphqlError(apolloError)

  if (isValidationError(firstError)) {
    const formCompatibleError = isEstagio ? adaptValidationErrorToForm(firstError, apolloError) : apolloError

    const handledError = handleError({
      error: formCompatibleError,
      suppressNotificationError: true,
    })

    const errorObject: ErrorObject<AtendimentoIndividualInput> = isRetificacao
      ? getAtendimentoIndividualInputErrorsFromRetificacao(handledError)
      : handledError

    const convertedErrors = convertSoapErrorsFromBackend(errorObject, flags, isAtendimentoOdonto)

    showValidationErrorsSoapModal({ errors: convertedErrors })

    // eslint-disable-next-line no-console
    console.error(`Erro ao finalizar atendimento ${tipoAtendProf}`, JSON.stringify(handleValidationError(firstError)))
  }

  throw apolloError
}

const adaptValidationErrorToForm = (firstError: any, error: any) => {
  const validationError = firstError.extensions.validationError

  if (validationError.atendimentoInput) {
    return {
      ...error,
      graphQLErrors: [
        {
          ...firstError,
          extensions: {
            ...firstError.extensions,
            validationError: validationError.atendimentoInput,
          },
        },
      ],
    }
  }
  return error
}
